<template>
  <div>
    <v-simple-table fixed-header>
      <thead>
        <tr>
          <th class="text-left">Descripción</th>
          <th class="text-left">Observaciones</th>
          <th class="text-center">Fecha</th>
          <th class="text-center">Documento</th>
          <th class="text-center">Formato</th>
          <th class="text-center" width="120">F. Actualización</th>
          <th class="text-left"></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="documento in listadoDocumentosRelacionados">
            <tr :key="documento.id">
              <td width="35%" class="pl-1">{{ documento.descripcion }}</td>
              <td>{{ documento.observaciones }}</td>
              <td align="center">
                {{ new Date(`${documento.fecha} 00:00:0`).toLocaleDateString() }}
              </td>
              <td align="center">
                <v-tooltip v-if="documento.publicKey && documento.extension === 'pdf'" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="verDocumentoRelacionado(documento)">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver PDF</span>
                </v-tooltip>
                <v-tooltip v-if="documento.publicKey" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="descargarDocumentoRelacionado(documento)">
                      <v-icon
                        color="blue darken-1">
                        mdi-cloud-download
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Descargar</span>
                </v-tooltip>
              </td>
              <td align="center">
                <!-- <v-icon>
                  {{getIcono(documento.extension)}}
                </v-icon> -->
                <span> {{documento.extension ? documento.extension : ''}} </span>
              </td>
              <td>
                <template>
                  <fecha-humano :fecha="new Date(documento.updatedAt)"></fecha-humano>
                </template>
              </td>
              <td align="end" width="105">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="editarDocumentoRelacionado(documento)">
                      <v-icon
                        v-if="!documento.publicKey"
                        color="success">
                        mdi-file-plus-outline
                      </v-icon>
                      <v-icon
                        v-else
                        color="warning">
                        mdi-file-edit-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span v-if="!documento.publicKey">Agregar PDF</span>
                  <span v-else>Editar PDF</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="borrarDocumentoRelacionado(documento)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Borrar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
      </tbody>
    </v-simple-table>
    <v-dialog
        v-if="progresoDescarga"
        v-model="mostrarDescargando"
        width="200"
        persistent>
        <v-card>
          <v-card-title class="secondary--text">
            <v-row justify="center">
              Descargando
            </v-row>
          </v-card-title>
          <v-row class="pa-4" justify="center" align="center">
            <v-progress-circular
              :size="100"
              :width="15"
              :value="progresoDescarga"
              color="blue darken-1"
              dark>
              <h3>{{ progresoDescarga }}%</h3>
            </v-progress-circular>
          </v-row>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import mixDescargarArchivo from '@/helpers/mixDescargarArchivo';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoDocumentosRelacionadosDesktop',
  mixins: [mixDescargarArchivo],
  props: {
    listadoDocumentosRelacionados: {
      type: Array,
      required: true,
    },
  },
  components: {
    FechaHumano,
  },
  data() {
    return {
      iconosFormatos: [
        { extension: 'pdf', icon: 'fa-file-pdf' },
        { extension: 'xlsx', icon: 'fa-file-excel' },
        { extension: 'xls', icon: 'fa-file-excel' },
        { extension: 'doc', icon: 'fa-file-word' },
        { extension: 'docx', icon: 'fa-file-word' },
        { extension: 'ppt', icon: 'fa-file-powerpoint' },
        { extension: 'pptx', icon: 'fa-file-powerpoint' },
        { extension: 'zip', icon: 'fa-file-archive' },
        { extension: 'jpg', icon: 'fa-file-image' },
        { extension: 'jpeg', icon: 'fa-file-image' },
        { extension: 'png', icon: 'fa-file-image' },

      ],
      mostrarDescargando: false,
      progresoDescarga: null,
    };
  },
  methods: {
    editarDocumentoRelacionado(documentoRelacionado) {
      eventBus.$emit('editar-documento-relacionado', documentoRelacionado);
    },
    borrarDocumentoRelacionado(documentoRelacionado) {
      eventBus.$emit('borrar-documento-relacionado', documentoRelacionado);
    },
    verDocumentoRelacionado(documentoRelacionado) {
      eventBus.$emit('ver-documento-relacionado', documentoRelacionado);
    },
    descargarDocumentoRelacionado(documentoRelacionado) {
      this.mixDescargarArchivo(documentoRelacionado, 'documentosRelacionados');
    },
    getIcono(extension) {
      const icono = this.iconosFormatos
        .find((iconoFormato) => iconoFormato.extension === extension);

      return icono.icon;
    },
  },
};
</script>

<style lang="scss">
</style>
